import React, { useContext } from "react";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { Context } from "../../context";
import Filter from "./Filter";
import { Slide, Box, SvgIcon, Modal, Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import Constant from "../../util/constants";
import "./SearchBar.css";
import { Paper, useMediaQuery } from "@mui/material";
import LocationFilters from "./LocationFilters";

const SearchBar = React.forwardRef(
  (
    {
      applyFilter,
      toggleDirection,
      mapFilter,
      setCenter,
      onDirectionHandler,
      onFilter,
      loading,
      networkFiltersArr,
      areNetworkFiltersFetched,
      onFavouriteClick,
      filterOpen,
      setFilterOpen,
      fsContainer,
    },
    ref
  ) => {
    const { maps, auth } = useContext(Context);
    const theme = useTheme();
    const belowSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleMenuClick = (event) => {
      const { authenticated, setAuthenticated } = auth;
      if (!authenticated.isAuth) {
        setAuthenticated({
          ...authenticated,
          authPopup: !0,
          redirectTo: Constant.paths.HOME,
        });
        return;
      }

      setFilterOpen(prev => !prev);
    };

    const handleClose = () => {
      setFilterOpen(false);
    };

    const handleRouterPlanner = () => {
      const { setMapsData, mapsData } = maps;
      setMapsData({
        ...mapsData,
        routePlanner: !0,
      });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      const {
        places: { PlacesService },
      } = window.google.maps;
      const { mapInstance } = window;
      const service = new PlacesService(mapInstance);
      const request = {
        query: e.target.elements["location"].value,
        fields: ["name", "geometry"],
      };
      service.findPlaceFromQuery(request, (result) => {
        const {
          location: { lat, lng },
        } = result[0].geometry;
        const { directionRendererInstance } = window;
        directionRendererInstance &&
          directionRendererInstance.set("directions", null);
        setCenter({
          lat: lat(),
          lng: lng(),
        });
      });
    };



    return (
      <div
        className={`search-bar-location ${
          maps.mapsData?.widget && belowSmScreen ? "widget-open" : ""
        }`}
        style={{ 
          position: 'fixed', 
          zIndex: 1300, 
          top: '8px', 
          left: maps.mapsData?.widget ? '0px' : (belowSmScreen ? '50%' : 'auto'),
          right: maps.mapsData?.widget || belowSmScreen ? 'auto' : 'calc(100% - 460px)',
          marginLeft: maps.mapsData?.widget || belowSmScreen ? '0' : '16px',
          transform: belowSmScreen && !maps.mapsData?.widget ? 'translateX(-50%)' : 'none',
          width: belowSmScreen ? 'calc(100% - 32px)' : '444px'
        }}
      >
        <Slide in={true} direction="right" mountOnEnter unmountOnExit>
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              mt: "10px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              boxShadow: "0px 6px 16px rgba(145, 158, 171, 0.24)",
              borderRadius: "12px"
            }}
            className="relative"
            onSubmit={handleSubmit}
          >
            <Tooltip title="Menu" placement="bottom">
              <IconButton
                sx={{ p: "10px" }}
                aria-label="menu"
                onClick={handleMenuClick}
              >
                <Icon icon="eva:menu-fill" width={24} height={24} color="#637381" />
              </IconButton>
            </Tooltip>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search for a location"
              inputProps={{ "aria-label": "search google maps" }}
              name="location"
              inputRef={ref}
            />
            <Tooltip title="Search" placement="bottom">
              <IconButton
                type="submit"
                sx={{ p: "10px" }}
                aria-label="search"
                disabled
              >
                <Icon icon="eva:search-fill" width={24} height={24} color="#637381" />
              </IconButton>
            </Tooltip>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <Tooltip title="Directions" placement="bottom">
              <IconButton
                color="primary"
                sx={{ p: "10px" }}
                aria-label="directions"
                onClick={handleRouterPlanner}
              >
                <Icon icon="eva:navigation-2-outline" width={24} height={24} color="var(--app-color)" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Filters" placement="bottom">
              <IconButton
                color="primary"
                sx={{
                  p: 0,
                  m:0
                }}
                aria-label="directions"
              >
              <LocationFilters
                onFilter={onFilter}
                mapFilter={mapFilter}
                loading={loading}
                networkFiltersArr={networkFiltersArr}
                areNetworkFiltersFetched={areNetworkFiltersFetched}
                fsContainer={fsContainer}
              />
              </IconButton>
            </Tooltip>
          </Paper>
        </Slide>
      </div>
    );
  }
);

export default React.memo(SearchBar);
